<template>

    <Toast/>

    <MenuHealthCompact/>

    <div class="px-6 surface-overlay relative">

        <ul class="list-none py-2 px-0 m-0 flex align-items-center font-medium overflow-x-auto w-full">
            <li class="pr-3"><a class="cursor-pointer">Account</a></li>
            <li class="px-2"><i class="pi pi-angle-right text-900"></i></li>
            <li class="px-2"><a class="cursor-pointer text-900 white-space-nowrap">Simply Investing Admin Interface</a></li>
        </ul>

        <div v-if="activeTab === 1" class="grid">
            <div class="col-12 md:col-12">
                <div class="card p-fluid">

                    <h3>Manage Clients</h3>

                    <div class="grid">
                        <ul class="list-none p-0 m-0 flex lg:align-items-center flex-column lg:flex-row select-none">
                            <li>
                                <a @click="callNewClient" v-ripple
                                   class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round cursor-pointer transition-colors transition-duration-150 p-ripple">
                                    <i class="pi pi-plus-circle mr-2"></i>
                                    <span>New Client</span>
                                </a>
                            </li>
<!--                            <li>-->
<!--                                <a @click="callNewClient" v-ripple-->
<!--                                   class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round cursor-pointer transition-colors transition-duration-150 p-ripple">-->
<!--                                    <i class="pi pi-plus-circle mr-2"></i>-->
<!--                                    <span>Upload Stock History</span>-->
<!--                                </a>-->
<!--                            </li>-->
                        </ul>
                    </div>

                    <DataTable
                        v-model:lazyParams="lazyParams"
                        :value="clients"
                        lazy
                        paginator
                        size="small"
                        :ptOptions="{ mergeSections: true, classNameMergeStrategy: 'replace' }"
                        :pt="{headerCell: { class: 'py-1 px-2' }, bodyCell: { class: 'p-0' }, bodyRow: { class: 'p-0' }}"
                        :rows="100"
                        :totalRecords="totalRecords"
                        :loading="submitted"
                        :rowsPerPageOptions="[10, 20, 50, 100]"
                        :sortMode="'single'"
                        :rowHover="true"
                        :striped-rows="true"
                        :reorderableColumns="true"
                        filterDisplay="menu"
                        responsiveLayout="scroll"
                        :globalFilterFields="['id', 'name', 'email', 'mobile']"
                        @page="onPage"
                        @sort="onSort"
                        @filter="onFilter">

                        <template #header>
                            <div class="p-grid">
                                <div class="grid">
                                    <div class="col-12 lg:col-6 p-2">
                                        <MultiSelect :modelValue="selectedColumns" :options="columnsFullList"
                                                     optionLabel="header" @update:modelValue="onToggleColumns"
                                                     display="chip"
                                                     placeholder="Select Columns"/>
                                    </div>
                                    <div class="col-12 lg:col-6 p-2">
                                        <Dropdown v-model="selectedStandardFilter" :options="statusTypes"
                                                  optionLabel="name" optionValue="code" placeholder="Select a Filter"
                                                  @update:modelValue="onToggleStandardFilters"/>
                                    </div>

                                </div>

                                <div class="grid">
                                    <div class="col-12 lg:col-6 p-2">
                                        <Button type="button" icon="pi pi-filter-slash" label="Clear Search"
                                                class="p-button-outlined p-ml-2" @click="clearFilter()"/>
                                    </div>
                                    <div class="col-12 lg:col-6 p-2">
                                        <Button type="button" icon="pi pi-replay" label="Restore to Original View"
                                                class="p-button-outlined" @click="restoreToOriginal()"/>
                                    </div>
                                </div>

                                <div class="p-col-12 p-md-2">
                                    <span class="p-input-icon-left">
                                        <i class="pi pi-search"/>
                                        <InputText v-model="filters['global'].value"
                                                   placeholder="Keyword Search on ID, Name, Email or Mobile (Please press enter to search)"
                                                   style="width: 100%"
                                                   @keyup.enter="onSearch"/>
                                    </span>
                                </div>

                            </div>
                        </template>

                        <template #empty>
                            No clients found.
                        </template>

                        <template #loading>
                            Loading clients. Please wait.
                        </template>

                        <Column
                            field="selectAnOption"
                            header=""
                            :headerStyle="{ width: '2rem' }"
                            :bodyStyle="{ width: '2rem', padding: '0.25rem' }">
                            <template #body="{ data, index }">
                                <Button icon="pi pi-ellipsis-v" class="p-button-sm p-button-text p-button-rounded m-0"
                                        @click="$refs['menu' + index].toggle($event)"/>
                                <Menu
                                    :ref="'menu' + index"
                                    :model="getFilteredItems(data)"
                                    :popup="true"/>
                            </template>
                        </Column>

                        <Column :headerStyle="{ width: '2rem' }"
                                :bodyStyle="{ width: '10rem', padding: '0.25rem' }" v-for="col in selectedColumns"
                                :key="col.field" :field="col.field" :header="col.header"
                                :sortable="col.sortable">
                            <template v-if="col.field === 'id'" #body="{ data }">
                                <span class="p-column-title">ID</span>
                                {{ data.id }}
                            </template>

                            <template v-else-if="col.field === 'name'" #body="{ data }">
                                <span class="p-column-title">Name</span>
                                <a href="javascript:void(0)" @click="onClientNameClick(data)">
                                    {{ data.name }}
                                </a>
                            </template>

                            <template v-else-if="col.field === 'type'" #body="{ data }">
                                <span class="p-column-title">Type</span>
                                <span v-if="data.type === 'N'" :class="'client-badge status-' + data.type">Natural Person (Adult)</span>
                                <span v-else-if="data.type === 'M'" :class="'client-badge status-' + data.type">Natural Person (Minor)</span>
                                <span v-else-if="data.type === 'J'" :class="'client-badge status-' + data.type">Juristic Person</span>
                            </template>

                            <template v-else-if="col.field === 'status'" #body="{ data }">
                                <span class="p-column-title">Status</span>
                                <span v-if="data.status === 'I'"
                                      :class="'status-badge status-' + data.status">Inactive</span>
                                <span v-else-if="data.status === 'P'" :class="'status-badge status-' + data.status">Pending</span>
                                <span v-else-if="data.status === 'A'" :class="'status-badge status-' + data.status">Active</span>
                            </template>

                            <template v-else #body="{ data }">
                                {{ data[col.field] }}
                            </template>
                        </Column>
                    </DataTable>

                </div>
            </div>
        </div>

        <div v-if="activeTab === 2" class="grid">
            <div class="col-12 md:col-12">
                <div class="card p-fluid">

                    <h3>Reset Password for Client {{ this.client.name }}</h3>

                    <div class="field">
                        <label for="password1">New Password</label>
                        <InputText id="password1" type="password" v-model.trim="updatePasswordInfo.password1"/>
                    </div>

                    <div class="field">
                        <label for="password2">Verify Password</label>
                        <InputText id="password2" type="password" v-model.trim="updatePasswordInfo.password2"/>
                    </div>

                    <Button label="Reset Password" class="mr-2 mb-2" :loading="submitted" @click="resetPassword"></Button>
                    <Button label="Cancel" class="mr-2 mb-2" :loading="submitted" @click="callReset"></Button>

                </div>
            </div>
        </div>

    </div>

    <IsoEvolveFooter/>

</template>

<script>
import IsoEvolveFooter from "@/components/heading/authentication/IsoEvolveFooter.vue";
import MenuHealthCompact from "@/components/menu/health/MenuHealthCompact.vue";
import {useUserStore} from "@/stores/UserStore";
import UserService from "@/service/UserService";
import numeral from "numeral";
import axios from "axios";
import ClientService from "@/service/ClientService";
import {FilterMatchMode, FilterOperator} from "primevue/api";
import Icd10CodeService from "@/service/Icd10CodeService";
import SimplyInvestingService from "@/service/SimplyInvestingService";

export default {
    components: {
        IsoEvolveFooter, MenuHealthCompact
    },
    setup() {
        const userStore = useUserStore()

        return {
            userStore
        }
    },
    created() {
        this.initFilters();
        this.icd10CodeService = new Icd10CodeService();

        this.columnsDefault = [
            {field: 'name', header: 'Name', sortable: true},
            {field: 'firstName', header: 'First Name', sortable: true},
            {field: 'preferredName', header: 'Preferred Name', sortable: true},
            {field: 'lastName', header: 'Last Name', sortable: true},
            {field: 'email', header: 'Email', sortable: true},
            {field: 'mobile', header: 'Mobile', sortable: true},
            {field: 'type', header: 'Type', sortable: true},
            {field: 'status', header: 'Status', sortable: true}
        ];

        this.columnsFullList = [
            {field: 'companyId', header: 'Company ID', sortable: true},
            {field: 'id', header: 'ID', sortable: true},
            {field: 'name', header: 'Name', sortable: true},
            {field: 'firstName', header: 'First Name', sortable: true},
            {field: 'preferredName', header: 'Preferred Name', sortable: true},
            {field: 'lastName', header: 'Last Name', sortable: true},
            {field: 'email', header: 'Email', sortable: true},
            {field: 'mobile', header: 'Mobile', sortable: true},
            {field: 'type', header: 'Type', sortable: true},
            {field: 'status', header: 'Status', sortable: true},
            {field: 'category', header: 'Category', sortable: true}
        ];

        this.selectedColumns = this.columnsDefault;

        this.standardFilters = [
            {field: 'active', header: 'Active Clients'},
            {field: 'inactive', header: 'Inactive Clients'},
            {field: 'pending', header: 'Pending Clients'},
            {field: 'natural', header: 'Natural Person (Adult)'},
            {field: 'minor', header: 'Natural Person (Minor)'},
            {field: 'juristic', header: 'Juristic Type'}
        ];
    },
    async mounted() {
        await this.loadCompanyContext();
    },
    data() {

        return {
            profile: {},
            updatePasswordInfo: {},
            fileClientImport: null,
            submitted: false,
            companyConfiguration: {},
            activeTab: 1,
            totalRecords: 0,
            filters: null,
            search: null,
            selectedColumns: null,
            columnsDefault: null,
            columnsFullList: null,
            selectedStandardFilter: null,
            lazyParams: {
                first: 0,
                rows: 100,
                sortField: null,
                sortOrder: 1,
                filters: {}
            },
            clients: [],
            client: {},
            statusTypes: [
                {name: 'Active', code: 'A'},
                {name: 'Inactive', code: 'I'},
                {name: 'Pending', code: 'P'}
            ],
            confirmationTypes: [
                {name: 'Yes', code: 'Y'},
                {name: 'No', code: 'N'}
            ],
        }
    },
    watch: {
        'userStore.activeCompanyId': {
            immediate: false,
            async handler(newCompanyId, oldCompanyId) {
                if (!newCompanyId || newCompanyId === oldCompanyId) {
                    return;
                }

                console.log(
                    '[Appointments][watch] Company changed:',
                    oldCompanyId,
                    '→',
                    newCompanyId
                );

                await this.loadCompanyContext();
            }
        }
    },
    methods: {
        async loadCompanyContext() {
            try {
                try {
                    // Attempt to get user data
                    const userData = await UserService.getUser(this.userStore.user.id);
                    this.profile = userData.data;
                } catch (e) {
                    console.error("[AppointmentsNew][mounted] Error fetching user data = ", e);
                    this.userStore.clearUser();
                    this.$router.push('login');
                    return;
                }

                this.profile.companyId = this.userStore.activeCompanyId;

            } catch (e) {
                console.error("[ProfileAccount][mounted] Error fetching user data = ", e);
                this.userStore.clearUser();
                this.$router.push('login');
            }

            await this.initFilters();

            if (!this.filters) this.filters = {};
            if (!this.search) this.search = '';

            await this.loadData();

        },
        handleFileUploadClientImport(event) {
            this.fileClientImport = event.target.files[0];
        },
        async submitFileClientImport() {
            this.submitted = true;

            if (!this.fileClientImport) {
                this.$toast.add({
                    severity: 'error',
                    summary: 'Error',
                    detail: 'No file selected.',
                    life: 3000
                });
            }

            const formData = new FormData();
            formData.append('file', this.fileClientImport);

            var url = "/api/providercomponent/upload/generic/comma";

            try {
                const response = await axios.post(url, formData, {
                    headers: {
                        'Authorization': `Bearer ${this.userStore.accessToken}`,
                        'Content-Type': 'multipart/form-data',
                    },
                });

                console.log('[ProfileAdmin][submitFile] Upload successful = ', response.data);

                this.$toast.add({
                    severity: 'success',
                    summary: 'Successful',
                    detail: 'Uploaded health insurance rates',
                    life: 3000
                });

            } catch (error) {
                console.error('Error uploading file:', error);
                this.$toast.add({
                    severity: 'error',
                    summary: 'Error',
                    detail: 'Upload of health insurance rates NOT successful',
                    life: 3000
                });
            }

            this.fileClientImport = null;
            this.$refs.fileInputClientImport.value = null;
            this.submitted = false;
        },
        async loadData() {
            this.submitted = true;
            try {
                console.log("[Clients][loadData] Fetching clients with params:", this.lazyParams, "Search:", this.filters['global']?.value);

                const response = await ClientService.getBasicCompanyClientsLazyLoading(
                    this.profile.companyId,
                    this.lazyParams,
                    (this.filters['global']?.value ?? '').trim(),
                    this.selectedStandardFilter);

                console.log("[Clients][loadData] API Response:", response);
                console.log("[Clients][loadData] response.data.content:", response.data?.content);
                console.log("[Clients][loadData] response.data.totalElements:", response.data?.totalElements);

                this.clients = Array.isArray(response.data.content) ? response.data.content : [];
                this.totalRecords = response.data?.totalElements || 0;

                console.log("[Clients][loadData] Clients Updated:", this.clients, "Total Records:", this.totalRecords);

                return this.clients;
            } catch (error) {
                console.error("[Clients][loadData] Error loading clients:", error);
                this.clients = [];
                this.totalRecords = 0;
            } finally {
                this.submitted = false;
            }
        },
        async initFilters() {
            this.filters = {
                'global': {value: null, matchMode: FilterMatchMode.CONTAINS},
                'id': {
                    operator: FilterOperator.AND,
                    constraints: [{value: null, matchMode: FilterMatchMode.STARTS_WITH}]
                },
                'name': {
                    operator: FilterOperator.AND,
                    constraints: [{value: null, matchMode: FilterMatchMode.STARTS_WITH}]
                },
                'email': {
                    operator: FilterOperator.AND,
                    constraints: [{value: null, matchMode: FilterMatchMode.STARTS_WITH}]
                },
                'mobile': {
                    operator: FilterOperator.AND,
                    constraints: [{value: null, matchMode: FilterMatchMode.STARTS_WITH}]
                }

            };

        },
        onPage(event) {
            console.log("[Clients][onPage] Page Event:", event);
            this.lazyParams.first = event.first;
            this.lazyParams.rows = event.rows;
            this.loadData();
        },
        onSort(event) {
            this.lazyParams.sortField = event.sortField;
            this.lazyParams.sortOrder = event.sortOrder;
            this.loadData();
        },
        onFilter(event) {
            this.lazyParams.filters = event.filters;
            this.loadData();
        },
        onSearch() {
            console.log("[Clients][onSearch] Searching with:", this.filters['global'].value);
            this.lazyParams.first = 0;
            this.loadData();
        },
        onToggleStandardFilters() {
            console.log("[Clients][onToggleStandardFilters] Applying Standard Filter:", this.selectedStandardFilter);
            this.lazyParams.first = 0;
            this.loadData();
        },
        clearFilter() {
            this.initFilters();
            console.log("🔄 Clearing search filters...");
            // this.filters['global'] = { value: '' }; // Reset global search
            this.lazyParams.filters = {}; // Clear all column filters
            this.lazyParams.first = 0; // Reset pagination to first page
            this.loadData();
        },
        formatAmount(value) {
            if (value) {
                return numeral(String(value)).format('0,0.00');
            } else {
                return numeral(String(0)).format('0,0.00');
            }
        },
        onToggleColumns(value) {
            this.selectedColumns = this.columnsFullList.filter(col =>
                value.some(selected => selected.field === col.field)
            );
        },
        getFilteredItems(data) {
            const items = [];

            items.push({
                label: 'Reset Password',
                class: 'mb-4 mr-4 ml-4 mt-4',
                command: () => {
                    this.callResetPassword(data);
                }
            });

            items.push({
                label: 'Change Access',
                class: 'mb-4 mr-4 ml-4 mt-4',
                command: () => {
                    this.callUpdateHealthcareClient(data);
                }
            });

            items.push({
                label: 'Delete',
                class: 'mb-4 mr-4 ml-4 mt-4',
                command: () => {
                    this.callDeleteClient(data);
                }
            });

            return items;
        },
        callResetPassword(data) {
            this.activeTab = 2;
            this.client = data;
        },
        callReset() {
            this.activeTab = 1;
        },
        async resetPassword() {
            this.submitted = true;

            if (this.updatePasswordInfo.password1.trim()) {
                if (this.updatePasswordInfo.password1.length < 8) {
                    console.log("[Profile][processUpdatePassword] Got into password length check. Password1 = ", this.updatePasswordInfo.password1);
                    this.$toast.add({
                        severity: 'error',
                        summary: 'Unsuccessful',
                        detail: 'Password needs to be at least 8 characters',
                        life: 3000
                    });
                } else if (this.updatePasswordInfo.password1 !== this.updatePasswordInfo.password2) {
                    console.log("[Profile][processUpdatePassword] Got into password NOT equals password2 check. Password1 = ", this.updatePasswordInfo.password1);
                    this.$toast.add({severity: 'error', summary: 'Unsuccessful', detail: 'Passwords do not match', life: 3000});
                } else if (this.updatePasswordInfo.password1 === this.updatePasswordInfo.password2) {
                    console.log("[Profile][processUpdatePassword] Got into password equals password2 check. Password1 = ", this.updatePasswordInfo.password1);
                    this.$toast.add({severity: 'success', summary: 'Successful', detail: 'Passwords do match', life: 3000});

                    try {
                        var clientDto = {
                            id: this.client.id,
                            password: this.updatePasswordInfo.password1,
                        };

                        const response = await SimplyInvestingService.resetPassword(this.client.id, clientDto);
                        console.log('[ProfileSiAdmin][updatePhoneCall] Response = ', response);

                        this.$toast.add({
                            severity: 'success',
                            summary: 'Successful',
                            detail: 'Resetted password',
                            life: 3000
                        });
                    } catch (error) {
                        console.error('[ProfileSiAdmin][updatePhoneCall] Error:', error);

                        this.$toast.add({
                            severity: 'error',
                            summary: 'Error',
                            detail: 'Failed to reset password. Please try again.',
                            life: 3000
                        });
                    }
                }
            }

            this.updatePasswordInfo = {};
            this.submitted = false;
        }
    }
};
</script>

<style scoped>
a {
    text-decoration: none;
}
</style>
